import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { techsbookApi } from "./Builder/techsbook.api";
import { scheduleApi } from "./Builder/schedule.api";
import { jobsApi } from "./Builder/jobs.api";
import { dashboardApi } from "./Builder/dashboard.api";
import techsbookSlice from "./Slice/techsbookSlice";
import scheduleSlice from "./Slice/scheduleSlice";
import jobsSlice from "./Slice/jobsSlice";
import dashboardSlice from "./Slice/dashboardSlice";
import {messagingApi} from "./Builder/messaging.api";
import messagingSlice from "./Slice/messagingSlice";
import registerSlice from "./Slice/registerSlice";

const rootReducer = combineReducers({
  techsbookSlice,
  scheduleSlice,
  jobsSlice,
  dashboardSlice,
  messagingSlice,
  registerSlice
});

export const store = configureStore({
  reducer: {
    [techsbookApi.reducerPath]: techsbookApi.reducer,
    [scheduleApi.reducerPath]: scheduleApi.reducer,
    [jobsApi.reducerPath]: jobsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [messagingApi.reducerPath]: messagingApi.reducer,
    rootReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(techsbookApi.middleware)
      .concat(scheduleApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(jobsApi.middleware)
      .concat(messagingApi.middleware),
});
